import { differenceInCalendarDays } from 'utils/dateUtils'

const dateMinRange = (startDate, endDate, range) => {
  if (differenceInCalendarDays(new Date(endDate), new Date(startDate)) < range) {
    return `Minimum ${range} days`
  }
}

export default dateMinRange
